/**Packages */
import axios from "axios";
import { default as config } from "./../firebase/config";

const URLS = {
    NEW_CHAT: "/chat/newChat",
    REPLY: "/chat/reply",
};

const newChat = async (token, canteenId, subject, content, userEmail = null, language) => {
    const data = await axios
        .post(
            `${config.API_URL}/${URLS.NEW_CHAT}`,
            {
                canteenId,
                subject,
                content,
                userEmail,
                lang: language,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            },
        )
        .then(response => {
            return response?.status === 200 && response?.data?.success;
        })
        .catch(err => {
            console.warn(err);
            return false;
        });

    return data;
};

const reply = async (token, chatId, content) => {
    const data = await axios
        .post(
            `${config.API_URL}/${URLS.REPLY}`,
            {
                id: chatId,
                content,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            },
        )
        .then(response => {
            return response?.status === 200 && response?.data?.success;
        })
        .catch(err => {
            console.warn(err);
            return false;
        });

    return data;
};

export const chatAPIs = {
    newChat,
    reply,
};
